var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlert({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 15,
    fill: "#FFC940",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 16H14V10H16M16 20H14V18H16M15 5C13.6868 5 12.3864 5.25866 11.1732 5.7612C9.95991 6.26375 8.85752 7.00035 7.92893 7.92893C6.05357 9.8043 5 12.3478 5 15C5 17.6522 6.05357 20.1957 7.92893 22.0711C8.85752 22.9997 9.95991 23.7362 11.1732 24.2388C12.3864 24.7413 13.6868 25 15 25C17.6522 25 20.1957 23.9464 22.0711 22.0711C23.9464 20.1957 25 17.6522 25 15C25 13.6868 24.7413 12.3864 24.2388 11.1732C23.7362 9.95991 22.9997 8.85752 22.0711 7.92893C21.1425 7.00035 20.0401 6.26375 18.8268 5.7612C17.6136 5.25866 16.3132 5 15 5Z",
    fill: "#FFC940"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/Alert.496e445f9ea4615c4f37ea3237eae0b8.svg";
export { ForwardRef as ReactComponent };